import { CancellationWindow, TeamRole } from 'modules/arena/onboarding/types';

export const ONBOARDING_STEPS = [
  'Sobre a arena',
  'Esportes',
  'Quadras',
  'Horário',
  'Equipe',
  'Cancelamento',
  'Plano',
  'Revisão',
];

export const SPORT_CHOICES = ['Beach Tennis', 'Pickleball', 'Futevôlei', 'Vôlei de Praia', 'Tênis'];

export const WEEK_DAYS = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'];

export const TEAM_ROLE_LABELS: Record<TeamRole, string> = {
  gestor: 'Gestor',
  recepcao: 'Recepção',
  instrutor: 'Instrutor',
};

export const CANCELLATION_OPTIONS: { value: CancellationWindow; label: string; description: string }[] = [
  {
    value: '24h',
    label: 'Até 24h antes',
    description: 'Reembolso integral se o jogador cancelar com 24h de antecedência.',
  },
  {
    value: '48h',
    label: 'Até 48h antes',
    description: 'Prazo mais rígido, indicado para quadras muito concorridas.',
  },
  {
    value: 'sem-reembolso',
    label: 'Sem reembolso',
    description: 'Cancelamentos não geram devolução do valor pago.',
  },
];

export interface SaasPlan {
  id: string;
  name: string;
  price: number;
  features: string[];
}

export const SAAS_PLANS: SaasPlan[] = [
  {
    id: 'basico',
    name: 'Básico',
    price: 99,
    features: ['1 unidade', 'Agenda e reservas', 'Split de pagamento'],
  },
  {
    id: 'profissional',
    name: 'Profissional',
    price: 129,
    features: ['Múltiplas unidades', 'Aulas e pacotes mensais', 'Torneios e mural'],
  },
  {
    id: 'rede',
    name: 'Rede',
    price: 199,
    features: ['Unidades ilimitadas', 'Relatórios avançados', 'Suporte prioritário'],
  },
];

export const PLATFORM_FEE_NOTE = '+ taxa de 2% da plataforma sobre transações processadas';
